import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IBridgeWithUuid } from '../../bridgesData/businessBridgesTable/models/iCalculatedBridge'

export const getJbpBridgesCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.JBPBridges, 'bridges-JBPBridges') as Crud<IBridgeWithUuid>
